import { RouteOptions } from './../models/route-options';
import { Component, OnInit } from '@angular/core';
import { PermissionsService } from '../shared/services/permissions.service';
import { Permission } from '../models/permission';

@Component({
  selector: 'app-global-settings',
  templateUrl: './global-settings.component.html',
  styleUrls: ['./global-settings.component.less']
})

export class GlobalSettingsComponent implements OnInit {
  private allLinks: PermittedRoute[] = [
    {includePermissions: ["grantEditionAdmin"], routeOptions: { ref: ['administrators'],   title: 'Administrators'   }},
    {includePermissions: ["nomadicAdministration"], routeOptions: { ref: ['general-settings'], title: 'General Settings' }},
    {includePermissions: ["nomadicAdministration"], routeOptions: { ref: ['welcome-settings'], title: 'Welcome Settings' }},
    {includePermissions: ["nomadicAdministration"], routeOptions: { ref: ['home-settings'], title: 'Home Settings' }},
    {includePermissions: ["nomadicAdministration"], routeOptions: { ref: ['community-settings'], title: 'Community Settings' }},
    {includePermissions: ["writeSamlConfig"], routeOptions: { ref: ['sso-settings'], title: 'SSO Settings' }},
    {includePermissions: ["readSamlConfig"], excludePermissions: ["writeSamlConfig"], routeOptions: { ref: ['view-sso-settings'], title: 'SSO Settings' }},
    {includePermissions: ["nomadicAdministration"], routeOptions: { ref: ['permissions'], title: 'User Permissions' }},
  ];
  public links: RouteOptions[] = [];

  constructor(private permissionsService: PermissionsService) { }

  ngOnInit(): void {
    this.permissionsService.retrievePermissions().subscribe(permissions => {
      this.links = this.allLinks.filter(link => {
        if (link.includePermissions) {
          if (!link.includePermissions.every(perm => permissions[perm])) {
            return false;
          }
        }
        if (link.excludePermissions) {
          if (link.excludePermissions.some(perm => permissions[perm])) {
            return false;
          }
        }
        return true;
      }).map(link => link.routeOptions);
    });
  }
}

interface PermittedRoute {
  routeOptions: RouteOptions;
  includePermissions?: Permission[];
  excludePermissions?: Permission[];
}


// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/global-settings/global-settings.component.ts